import { SVGProps, Ref, forwardRef } from 'react';

export const EllipsisVerticalOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M14 5c0-1.5-1-2-2-2s-2 .5-2 2 1 2 2 2 2-.5 2-2" fill="currentColor" />
                <path d="M14 12c0-1.5-1-2-2-2s-2 .5-2 2 1 2 2 2 2-.5 2-2" fill="currentColor" />
                <path d="M12 17c1 0 2 .5 2 2s-1 2-2 2-2-.5-2-2 1-2 2-2" fill="currentColor" />
            </g>
        </svg>
    )
);
EllipsisVerticalOutlinedSize24Glyph.displayName = 'EllipsisVerticalOutlinedSize24Glyph';
